const hostName = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_HOST_PROD:process.env.REACT_APP_HOST_TEST;


export default {

	hostName: hostName,
    receiptTracking: hostName + "/dof-api/dept/receipts/tracking",
    receiptMaster: hostName + "/dof-api/dept/receipts/master",
    userLogin: hostName + "/dof-api/guest/dept/users",
    users: hostName + "/dof-api/dept/users",
    dashboard: hostName + "/dof-api/dept/dashboards",
    agency: hostName + "/dof-api/dept/departments",
    services: hostName + "/dof-api/dept/services",
    serviceItems: hostName + "/dof-api/dept/service-items",
    references: hostName + "/dof-api/dept/references",
    kinds: hostName + "/dof-api/dept/ref/kinds",
    reports: hostName + "/dof-api/dept/reports",
    province: hostName + "/dof-api/dept/provinces",
    receiptManagement: hostName + "/dof-api/dept/receipts",
    help: hostName + "/dof-api/dept/help",
    logos: hostName + "/dof-api/guest/dept/departments/active/logos",
    logo: hostName + "/dof-api/dept/departments/dept/get/logo",
    
};